import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { Injector } from '@angular/core';
import { AbilitySubjectsRegistry, assertValidAbilityActionsInSimpleAbilityRequirement } from '@core/shared/ability';
import { ACCESS_SERVICE_PLUGIN_TOKEN, AccessServiceState, BaseAccessService, EndSessionRequest, GetSessionInfoRequest, OnSessionInitialized, OnSessionReloaded, OnSessionResumed } from '@core/shared/access';
import { ConfigService } from '@core/shared/config';
import { FeatureProvidersRegistry } from '@core/shared/feature';
import { firstValueFrom, map } from 'rxjs';
import { AppRequestService } from '../../api';
import { DevToolsRegistry } from '../../dev-tools';
import { AppMessageFactory } from '../../messages';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/config";
import * as i2 from "../../api";
import * as i3 from "../../messages";
import * as i4 from "@core/shared/feature";
export let AccessService = /*#__PURE__*/(() => {
  class AccessService extends BaseAccessService {
    get sessionId() {
      return this._sessionId;
    }
    constructor(config, api, messageFactory, injector, providersRegistry) {
      super();
      this.config = config;
      this.api = api;
      this.messageFactory = messageFactory;
      this.injector = injector;
      this._sessionId = null;
      const debug = injector.get(DevToolsRegistry);
      const pluginCtors = providersRegistry.getProviders(ACCESS_SERVICE_PLUGIN_TOKEN);
      debug.exposeDebugFunction(['Access', 'SessionInfo'], () => {
        return this._sessionInfo$.pipe(map(info => {
          return {
            ...info,
            programmaticAbilities: this.programmaticAbilities
          };
        }));
      });
      debug.exposeDebugFunction(['Access', 'Service Plugins'], () => {
        return pluginCtors;
      });
      this.setupPlugins(pluginCtors, injector);
    }
    setProgrammaticAbility(name, bias) {
      if (!IS_PRODUCTION) {
        assertValidAbilityActionsInSimpleAbilityRequirement(this.injector.get(AbilitySubjectsRegistry), name, 'AccessService.setProgrammaticAbility');
      }
      return super.setProgrammaticAbility(name, bias);
    }
    loadSessionInfo() {
      var _this = this;
      return _asyncToGenerator(function* (reload = false) {
        const req$ = _this.api.sendRequest(GetSessionInfoRequest, {
          reload
        });
        let response = null;
        try {
          response = yield firstValueFrom(req$);
        } catch (err) {
          // in case session fails to load for ANY reason, we want the app to treat user as guest and continue to render!
        }
        if (response?.sessionInfo) {
          _this._sessionInfo$.next(response.sessionInfo);
          _this._sessionId = response.sessionInfo.sessionState.sessionId;
          return true;
        } else {
          _this._sessionInfo$.next(null);
          _this._sessionId = null;
          return false;
        }
      }).apply(this, arguments);
    }
    startSession() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        // if(this.status === AccessServiceState.READY && sessionId === this._sessionId) return Promise.resolve(true)
        // if(sessionId === null) {
        // 	this.status$.next(AccessServiceState.READY)
        // 	this._sessionId = null;
        // 	this._sessionInfo$.next(null);
        // 	return true
        // }
        // if(this.isSessionActive(sessionId)) {
        // 	this.status$.next(AccessServiceState.READY)
        // 	this.events.next(new OnSessionInitialized(this.sessionInfo))
        // 	this.events.next(new OnSessionResumed(this.sessionInfo))
        // 	return true
        // } else {
        const hadSessionBefore = !!_this2._sessionId;
        yield _this2.loadSessionInfo();
        const sessionInfo = _this2.sessionInfo;
        const requiredScope = _this2.getRequiredSessionScope();
        // transition from none to none
        if (!sessionInfo && !hadSessionBefore) {
          yield _this2.startWithoutSession();
          _this2.status$.next(AccessServiceState.READY);
          return false;
        }
        // end existing session
        if (!sessionInfo) {
          yield _this2.endSession();
          _this2.status$.next(AccessServiceState.READY);
          return false;
        }
        // begin session, but scope mismatches
        if (sessionInfo.sessionState.sessionScope !== requiredScope) {
          yield _this2.endSession();
          _this2.status$.next(AccessServiceState.READY);
          return false;
        }
        _this2.status$.next(AccessServiceState.READY);
        _this2.events.next(new OnSessionInitialized(sessionInfo));
        _this2.events.next(new OnSessionResumed(sessionInfo));
        return true;
        // }
      })();
    }
    isSessionActive(sessionId) {
      const hasActiveSession = this._sessionId && !!this.sessionInfo;
      return hasActiveSession && sessionId === this._sessionId;
    }
    getAuthInfo() {
      const sessionInfo = this._sessionInfo$.getValue();
      const sess = sessionInfo?.sessionState;
      if (!sess) return null;
      return {
        authType: sess.auth.authType,
        authId: sess.auth.authId
      };
    }
    getRequiredSessionScope() {
      const platform = this.config.getPlatform();
      if (!platform) throw new Error('Configuration Error: platform is not specified');
      return platform === 'admin' ? 'admin' : 'frontend';
    }
    endSession() {
      var _superprop_getEndSession = () => super.endSession,
        _this3 = this;
      return _asyncToGenerator(function* () {
        // no await, this is just a side effect
        // must be called after endSession, else the backend will receive token header and try to validate the ended session.
        if (_this3._sessionId && !!_this3.sessionInfo) {
          _this3.api.sendRequest(EndSessionRequest, {}).subscribe();
        }
        // must be called in any case, do not wrap in isAnySessionActive check!
        _superprop_getEndSession().call(_this3);
        return true;
      })();
    }
    reloadSession() {
      var _this4 = this;
      return _asyncToGenerator(function* () {
        yield _this4.loadSessionInfo(true);
        _this4.events.next(new OnSessionReloaded(_this4.sessionInfo));
        return _this4.sessionInfo;
      })();
    }
    /** check of actions must be implemented with in-time injection because injecting AbilitySubjectsRegistry in constructor would result in issues! */
    simpleAbilityCheck(requirement, respectSuperuser = true, strict = false) {
      if (!IS_PRODUCTION) {
        assertValidAbilityActionsInSimpleAbilityRequirement(this.injector.get(AbilitySubjectsRegistry), requirement, 'AccessService.simpleAbilityCheck');
      }
      return super.simpleAbilityCheck(requirement, respectSuperuser, strict);
    }
    static {
      this.ɵfac = function AccessService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessService)(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.AppRequestService), i0.ɵɵinject(i3.AppMessageFactory), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i4.FeatureProvidersRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessService,
        factory: AccessService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessService;
})();